<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-row>
      <v-col
        style="max-width: 15rem !important"
        v-for="(table, index) in tables"
        :key="index"
        cols="12"
        md="3"
      >
        <sub-menu-card
          :title="table.title"
          :isSelected="table.name == $route.name"
          :itemKey="table.key"
          @click="subMenuClicked(table.name)"
        />
      </v-col>
    </v-row>
    <template v-if="$route.name == 'signingPersonRules'">
      <signing-person-rules />
    </template>
    <template v-else-if="$route.name == 'objectPersonRules'">
      <object-person-rules />
    </template>
    <template v-else-if="$route.name == 'representativePersonRules'">
      <representative-person-rules />
    </template>
  </v-container>
</template>

<script>
import math from '@/mixins/math'
import SubMenuCard from '@/components/cards/SubMenuCard'
import ObjectPersonRules from './objectPersonRules/ObjectPersonRules.vue'
import SigningPersonRules from './signingPersonRules/SigningPersonRules.vue'
import RepresentativePersonRules from './representativePersonRules/RepresentativePersonRules.vue'

export default {
  name: 'PersonRulesIndex',
  components: {
    SubMenuCard,
    ObjectPersonRules,
    SigningPersonRules,
    RepresentativePersonRules,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tables: [
        {
          key: 'object-person-rules',
          title: 'OBJEKTŲ ASMENYS',
          name: 'objectPersonRules',
        },
        {
          key: 'signing-person-rules',
          title: 'PASIRAŠANTYS ASMENYS',
          name: 'signingPersonRules',
        },
        {
          key: 'representative-person-rules',
          title: 'JA atstovų tikrinimo taisyklės',
          name: 'representativePersonRules',
        },
      ],
    }
  },
  methods: {
    subMenuClicked(route) {
      this.loading = true
       this.$nextTick(() => {
          this.loading = false
          this.$router.push({ name: route })
        })

    },
  },
}
</script>


<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>

